import { create } from 'zustand'

import { ConfirmDeleteActioningSchema } from '@/pages/campaign-module/actionings/list/components/table/schemas'
import { ConfirmDeleteCampaignSchema } from '@/pages/campaign-module/campaigns/list/components/table/schemas'
import { ConfirmDeleteTemplateSchema } from '@/pages/campaign-module/templates/list/components/table/schemas'

type DialogStore<T> = {
  open: boolean
  data: T | undefined
  onOpenChange: (open: boolean, data?: T) => void
}

export function createDialogStore<T>() {
  return create<DialogStore<T>>()((set) => ({
    open: false,
    data: undefined,
    onOpenChange: (open, data) => set({ open, data }),
  }))
}

export const useAuthLogoutDialog = createDialogStore<void>()
export const useDeleteTemplateDialog =
  createDialogStore<ConfirmDeleteTemplateSchema>()
export const useDeleteCampaignDialog =
  createDialogStore<ConfirmDeleteCampaignSchema>()
export const useDeleteActioningDialog =
  createDialogStore<ConfirmDeleteActioningSchema>()
